/**
 * Navigation Module
 * Handles mobile menu, smooth scrolling, and compact menu
 */

function initMobileMenu() {
    const menuToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.getElementById('mobile-menu');
    
    if (!menuToggle || !mobileMenu) return;
    
    const hamburgerIcon = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>';
    const closeIcon = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>';
    
    menuToggle.addEventListener('click', () => {
        mobileMenu.classList.toggle('hidden');
        const svg = menuToggle.querySelector('svg');
        svg.innerHTML = mobileMenu.classList.contains('hidden') ? hamburgerIcon : closeIcon;
    });
    
    // Close menu when clicking a link
    mobileMenu.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
            mobileMenu.classList.add('hidden');
            menuToggle.querySelector('svg').innerHTML = hamburgerIcon;
        });
    });
}

function initSmoothScroll() {
    if (document.body.dataset.smoothScroll === 'false') return;
    
    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const hash = this.getAttribute('href');
            if (!hash?.includes('#')) return;
            
            const targetId = hash.split('#')[1];
            const target = document.getElementById(targetId);
            
            if (target) {
                e.preventDefault();
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            }
        });
    });
}

function initCompactMenu() {
    const scrollToTopBtn = document.getElementById('scroll-to-top-btn');
    
    if (!scrollToTopBtn) return;
    
    scrollToTopBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}

function initFloatingActionButtons() {
    const floatingActions = document.getElementById('floating-actions');
    const fabScrollTop = document.getElementById('fab-scroll-top');
    const fabShare = document.getElementById('fab-share');
    
    if (!floatingActions) return;
    
    let ticking = false;
    
    // Show immediately on page load if scrolled
    if (window.scrollY > 150) {
        floatingActions.classList.add('show');
    }
    
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const scrolled = window.scrollY > 150;
                
                if (scrolled) {
                    floatingActions.classList.add('show');
                } else {
                    floatingActions.classList.remove('show');
                }
                
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
    
    if (fabScrollTop) {
        fabScrollTop.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
    
    if (fabShare) {
        fabShare.addEventListener('click', async (e) => {
            e.preventDefault();
            const shareData = {
                title: document.title,
                url: window.location.href
            };
            
            if (navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (err) {
                    if (err.name !== 'AbortError') {
                        console.log('Share failed:', err);
                    }
                }
            } else {
                await navigator.clipboard.writeText(window.location.href);
                const originalHTML = fabShare.innerHTML;
                fabShare.innerHTML = '<svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>';
                setTimeout(() => {
                    fabShare.innerHTML = originalHTML;
                }, 2000);
            }
        });
    }
}
